import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Theme from "./providers/Theme";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactGA from "react-ga4";

const shouldTrack = process.env.NODE_ENV === "production";
if (shouldTrack) {
  ReactGA.initialize([{ trackingId: "G-B0LLBFVK8G" }]);
}

ReactDOM.render(
  <React.StrictMode>
    <Theme>
      <App />
    </Theme>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
